<template>
    <div
      class="mt-4 bg-white rounded-lg flex flex-wrap justify-around items-center"
    >
      <a
        :class="{ 'text-green-500 font-semibold': tabReport == 1 }"
        class="link p-4 uppercase"
        @click="tabReport = 1"
      >
        Планировщик
      </a>
      <a
        :class="{ 'text-green-500 font-semibold': tabReport == 2 }"
        class="link p-4 uppercase"
        @click="tabReport = 2"
      >
        Отчетность
      </a>
    </div>

    <ReanimationPlan v-if="tabReport == 1" />
    <ReanimationReport v-if="tabReport == 2" />

  </template>
  
  <script>
import ReanimationPlan from "@/pages/ReanimationPlan.vue";
import ReanimationReport from "./ReanimationReport.vue";
  export default {
    name: "ReanimationPage",
    components: {
        ReanimationPlan,
        ReanimationReport
    },
    data() {
      return {
        tabReport: 1,
      };
    },
  };
  </script>
  
  <style scoped>
  .help-for-monke {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    color: #b5b5b5;
    font-weight: 600;
    font-size: 40px;
    line-height: normal;
    user-select: none;
  }
  </style>
  